/* GESKE homepage animations: scroll-reveal + gentle parallax for device images.
   Pure vanilla - no deps. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  // Parallax device images inside feature sections
  if (reduce) return;
  var sections = document.querySelectorAll('[data-parallax]');
  if (!sections.length) return;
  var items = [];
  sections.forEach(function (s) {
    s.querySelectorAll('[data-parallax-el]').forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-speed')) || 0.15;
      items.push({ section: s, el: el, speed: speed });
    });
  });
  if (!items.length) return;

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it.section.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return; // skip offscreen
        var centerDist = (r.top + r.height / 2) - vh / 2;
        var offset = -centerDist * it.speed; // move opposite to scroll direction
        it.el.style.transform = (it.el.dataset.baseTransform || '') + ' translateY(' + offset.toFixed(1) + 'px)';
      });
      ticking = false;
    });
  }

  // Capture any existing rotate from computed style so we don't lose it
  items.forEach(function (it) {
    var cs = window.getComputedStyle(it.el).transform;
    if (cs && cs !== 'none') it.el.dataset.baseTransform = cs;
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
